<script>
export default {
  name: 'LuckyDrawTable',
  props: {
    participants: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredParticipants() {
      return this.participants.filter(
        p =>
          p.additional_attributes && p.additional_attributes.lucky_draw === true
      );
    },
  },
  methods: {
    toggleSelection(id) {
      const newValue = [...this.value];
      const index = newValue.indexOf(id);

      if (index > -1) newValue.splice(index, 1);
      else newValue.push(id);

      this.$emit('input', newValue);
    },
  },
};
</script>

<template>
  <div class="overflow-x-auto rounded-2xl shadow border border-slate-200">
    <table class="min-w-full divide-y divide-slate-200 text-sm">
      <thead class="bg-slate-100 text-slate-700">
        <tr>
          <th class="px-4 py-2 text-left font-medium">#</th>
          <th class="px-4 py-2 text-left font-medium">Name</th>
          <th class="px-4 py-2 text-left font-medium">Email</th>
          <th class="px-4 py-2 text-left font-medium">Phone</th>
          <th class="px-4 py-2 text-left font-medium">Condominium</th>
          <th class="px-4 py-2 text-left font-medium">Registered At</th>
          <th class="px-4 py-2 text-left font-medium"></th>
        </tr>
      </thead>

      <tbody class="divide-y divide-slate-100">
        <tr
          v-for="(participant, index) in filteredParticipants"
          :key="participant.id"
          class="transition-colors"
          :class="{
            'bg-green-100 hover:bg-green-50 text-green-800 font-medium':
              participant.additional_attributes.won_prize,
            'hover:bg-slate-50': !participant.additional_attributes.won_prize,
          }"
        >
          <td class="px-4 py-2 text-slate-600">
            <input
              type="checkbox"
              :checked="value.includes(participant.id)"
              @change="toggleSelection(participant.id)"
            />
          </td>
          <td class="px-4 py-2 font-medium text-slate-800">
            {{ participant.name || '-' }}
          </td>
          <td class="px-4 py-2 text-slate-700">
            {{ participant.additional_attributes.unit_number || '-' }}
          </td>
          <td class="px-4 py-2 text-slate-700">
            {{ participant.phone_number || '-' }}
          </td>
          <td class="px-4 py-2 text-slate-700">
            {{ participant.additional_attributes.condominium || '-' }}
          </td>
          <td class="px-4 py-2 text-slate-700">
            {{
              new Date(
                participant.additional_attributes.lucky_draw_registered_at
              ).toLocaleString()
            }}
          </td>
          <td class="px-4 py-2">
            <woot-button
              icon="trophy"
              size="small"
              @click="$emit('assignWinner', participant.id)"
            />
          </td>
        </tr>

        <tr v-if="filteredParticipants.length === 0">
          <td colspan="7" class="px-4 py-6 text-center text-slate-500">
            No participants registered for lucky draw.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
